'use client';

import {FRONTEND_URL} from 'config';
import {ShareButton} from 'iq-interview_guides/components/share_button';
import {glassSurface, type HeroTone} from 'iq-interview_guides/components/hero_glass';
import {trackGuideApplyClicked} from 'iq-interview_guides/tracking';

interface HeroActionsProps {
  shareText: string;
  label?: string;
  tone?: HeroTone;
  companySlug?: string;
  positionSlug?: string;
}

export function HeroActions({
  shareText,
  label = "I'm applying for this position",
  tone = 'onLight',
  companySlug,
  positionSlug,
}: HeroActionsProps) {
  const params = new URLSearchParams({showUpcomingForm: '1'});
  if (companySlug) params.set('company', companySlug);
  if (positionSlug) params.set('position', positionSlug);
  const applyHref = `${FRONTEND_URL}/dashboard/my-interviews?${params.toString()}`;
  return (
    <div className='flex items-stretch gap-2 min-w-[270px]'>
      <a
        href={applyHref}
        onClick={() => void trackGuideApplyClicked(companySlug ?? positionSlug ?? '')}
        className={`px-4 py-2 text-sm font-medium rounded-lg whitespace-nowrap text-iq-black transition-colors ${glassSurface(tone)}`}>
        {label}
      </a>
      <ShareButton text={shareText} tone={tone} />
    </div>
  );
}
